import {
  DELETION_FLAG,
  FACILITY_STAFF_TIER,
  isEnabled,
  isFacilityKey,
  isOrganizationKey,
  isUserKey,
} from "@packages/core";
import { Link, createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";
import { LuPlus } from "react-icons/lu";

import { ButtonStyle, FacilityStaffTable, PageName } from "#components";
import {
  useCurrentUsername,
  useFacilityQuery,
  useFacilityStaff,
  useListedFacilityStaffs,
  useOperator,
  useTranslate,
} from "#services";
import { css } from "#styled-system/css";

export const Route = createFileRoute("/_authenticated/facilities/$facilityKey/staffs/")({
  component: Component,
});

function Component() {
  const { facilityKey } = Route.useParams();

  const { data: facility } = useFacilityQuery(facilityKey);
  const translate = useTranslate();
  const username = useCurrentUsername();
  // const [pageNumber, setPageNumber] = useState(0);
  // const [pageSize, setPageSize] = useState(25);

  const $operator = useOperator(isUserKey(username) && username);
  const $facilityStaff = useFacilityStaff(facilityKey, isUserKey(username) && username);

  const { pages } = useListedFacilityStaffs(
    { deleted: DELETION_FLAG.DEFAULT, facilityKey },
    // { pageSize },
  );

  const rows = useMemo(
    function () {
      return pages.flatMap(function (page) {
        return page.facilityStaffs;
      });
    },
    [pages],
  );

  return (
    <main
      className={css({
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        paddingX: "32px",
        paddingY: "24px",
      })}
    >
      <PageName>
        {facility
          ? translate("%StaffManagement.0%") + " - " + facility.name
          : translate("%Loading.0%")}
      </PageName>
      <p className={css({ fontSize: "24px", fontWeight: 700 })}>
        {translate("%StaffManagement.0%")}
      </p>

      <div
        className={css({
          alignItems: "flex-end",
          display: "flex",
          justifyContent: "space-between",
        })}
      >
        <div></div>
        <div>
          {(isEnabled($operator) ||
            isOrganizationKey(username) ||
            isFacilityKey(username) ||
            (isEnabled($facilityStaff) && $facilityStaff.tier <= FACILITY_STAFF_TIER.MANAGER)) && (
            <Link
              className={css({ alignItems: "center", display: "flex", gap: "8px" })}
              params={{ facilityKey }}
              to="/facilities/$facilityKey/staffs/registration"
            >
              <LuPlus />
              <p>{translate("%AddStaff.0%")}</p>
            </Link>
          )}
        </div>
      </div>

      <div className={css({ marginTop: "16px", overflowX: "auto", width: "100%" })}>
        <FacilityStaffTable
          action={function (facilityStaff) {
            return (
              <Link
                className={ButtonStyle({
                  appearance: "outlined",
                  borderRadius: "4px",
                  fontSize: "14px",
                  padding: "10px 16px",
                })}
                params={{ facilityKey, userKey: facilityStaff.userKey }}
                to="/facilities/$facilityKey/staffs/$userKey"
              >
                {translate("%Details.0%")}
              </Link>
            );
          }}
          rows={rows}
        />
      </div>

      {/* <div
        className={css({
          alignItems: "flex-start",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "16px",
        })}
      >
        <PageNumberController
          loading={loading}
          next={pageNumber < pages.length || fetchNextPage !== undefined}
          onNext={function (value) {
            fetchNextPage?.().then(function () {
              setPageNumber(value);
            });
          }}
          onPrevious={function (value) {
            setPageNumber(value);
          }}
          value={pageNumber}
        />
        <PageSizeSelector
          className={PaperStyle({})}
          onChange={function (value) {
            setPageSize(value);
          }}
          options={[25, 50, 100]}
          value={pageSize}
        />
      </div> */}
    </main>
  );
}
